module.exports = __webpack_public_path__ + "static/media/7.7b4d8e01.jpg";